import { styled } from '@mui/material';
import IconButton from '@mui/material/IconButton';
const AnthraciteIconButton = styled(IconButton)({
    color: '#fff',
    backgroundColor: '#383E42',
    '&:hover': {
        color: '#383E42',
        backgroundColor: '#fff',
    },
});
export default AnthraciteIconButton;
